import { request } from "services/api/util";

class PosCustomerService {
  async getListCustomers(param) {
    const config = {
      method: "get",
      url: `admin/existingCustomer`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async getDetailCustomer(customerId) {
    const config = {
      method: "get",
      url: `admin/existingCustomer/${customerId}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async updateCustomer(id, body) {
    const config = {
      method: "put",
      url: `admin/existingCustomer/${id}`,
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
}

export default new PosCustomerService();
